/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'spinner': {
    width: 50,
    height: 50,
    viewBox: '0 0 50 50',
    data: '<path pid="0" _fill="#C779D0" d="M25 5a20.14 20.14 0 0120 17.88 2.51 2.51 0 002.49 2.26A2.52 2.52 0 0050 22.33a25.14 25.14 0 00-50 0 2.52 2.52 0 002.5 2.81A2.51 2.51 0 005 22.88 20.14 20.14 0 0125 5z"><animateTransform attributeName="transform" type="rotate" from="0 25 25" to="360 25 25" dur="0.5s" repeatCount="indefinite"/></path>'
  }
})



// WEBPACK FOOTER //
// ./src/assets/icons/spinner.js